import { Button, Text, Link as VuiLink } from '@village/ui';
import styled from 'styled-components';
import { device } from 'utils/device';

const Container = styled.div`
    padding: 1rem;

    @media ${device.minLaptop} {
        grid-template-columns: 1fr 1fr;
    }

    @media ${device.minLaptopL} {
        margin: 0 auto;
        max-width: 1000px;
    }
`;

const Header = styled.div`
    max-width: 50rem;
    margin: 0 auto 3.75rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

const Title = styled(Text).attrs(() => ({ fontWeight: 400 }))`
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
    font-size: 3rem;
    line-height: 3.75rem;
    margin-top: 1.375rem;
    margin-bottom: 0.75rem;

    @media ${device.maxLaptop} {
        font-size: 2.125rem;
        line-height: 2.5rem;
    }
`;

const Wrapper = styled.div`
    margin-top: 2.5rem;
    gap: 2.5rem;

    @media ${device.minLaptop} {
        grid-template-columns: 1.5fr 1fr;
        gap: 6.25rem;
        margin-top: 5rem;
    }
`;

const VisitTypeNote = styled(Text)`
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
    font-size: 1.125rem;
    line-height: 1.75rem;
`;

const RoundedWrapper = styled.div`
    border-radius: 20px;
    border: 1px solid ${({ theme }) => theme.vui.colors.border.divider.default};
    padding: 2rem;
    color: ${({ theme }) => theme.vui.colors.text.secondary};

    &:not(:last-of-type) {
        margin-bottom: 2.5rem;
    }
`;

const RoundedWrapperTitle = styled(Text).attrs(() => ({ fontWeight: 400 }))`
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
    line-height: 2.25rem;
    font-size: 1.5rem;
    margin-bottom: 0.25rem;
`;

const RoundedWrapperListTitle = styled(Text)`
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
    margin-bottom: 0.5rem;
`;

const Link = styled(VuiLink)`
    color: ${({ theme }) => theme.vui.colors.text.slate600};
    text-decoration: underline;

    &:visited {
        color: ${({ theme }) => theme.vui.colors.text.slate600};
    }
`;

const RoundedWrapperList = styled.ul`
    margin: 0;
    padding: 0;

    &:first-of-type {
        margin-top: 0.75rem;
    }

    &:nth-last-of-type(2) {
        margin-bottom: 1rem;
    }
`;

const RoundedWrapperListItem = styled.li`
    margin-left: 1.5rem;
    color: ${({ theme }) => theme.vui.colors.text.slate600};
`;

// Adding context -- We are using the -2rem on the mobile graphic to offset the parent element spacing.
const RoundedWrapperPlatformStoreAnnouncement = styled(RoundedWrapper)`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    font-size: 1.125rem;
    line-height: 1.75rem;
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};

    @media ${device.maxTablet} {
        flex-direction: column;
        align-items: center;
    }

    & > img {
        margin-bottom: -2rem;
    }
`;

const RoundedWrapperPlatformStoreAnnouncementBody = styled(Text).attrs(() => ({ fontWeight: 400 }))`
    font-size: 1.125rem;
    line-height: 1.75rem;
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
`;

const EmailPlatformButton = styled(Button)`
    margin: 1.5rem 1rem 0 0;

    @media ${device.maxTablet} {
        width: 100%;
    }
`;

const MobilePlatformButton = styled(Button)`
    margin: 1.5rem 1rem 0 0;
    padding: 0;
    background: transparent;
    border: none;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

    @media (hover: hover) {
        &:hover:not(&:disabled) {
            border: none;
            background: black;
        }
    }
`;

const PlatformButtonImage = styled.img`
    display: inline-block;
    width: 10rem;
`;

export {
    Title,
    Container,
    RoundedWrapper,
    RoundedWrapperPlatformStoreAnnouncementBody,
    RoundedWrapperTitle,
    RoundedWrapperList,
    RoundedWrapperListItem,
    VisitTypeNote,
    Header,
    EmailPlatformButton,
    PlatformButtonImage,
    MobilePlatformButton,
    RoundedWrapperPlatformStoreAnnouncement,
    Wrapper,
    RoundedWrapperListTitle,
    Link,
};
